import { Injectable } from '@angular/core';
import {$WebSocket}from 'angular2-websocket/angular2-websocket';
import {environment} from '../../../environments/environment';
declare var SockJS
@Injectable()
export class WsService {
    
    init(){
        console.log("Creating ws")
        this.ws = new $WebSocket(environment.wsUrl);//, null, { initialTimeout: 3000, maxTimeout : 300000, reconnectIfNotNormalClose :true});
       //new SockJS(environment.wsUrl);//
}
  /*
    wsUrl = "wss://yourtutor.us/wb/r";
    imageUrl = "https://yourtutor.us/";
    backednUrl = "https://yourtutor.us/us/"; 
    wbBackendUrl = "https://yourtutor.us/wb/";
   */
  /*
    wsUrl = "wss://daskal.eu/wb/r";
    imageUrl = "https://daskal.eu/";
    backednUrl = "https://daskal.eu/daskal/"; 
    wbBackendUrl = "https://daskal.eu/wb/";
   */
  /*
  wsUrl = "ws://localhost:8080/wb/r";
    imageUrl = "http://localhost:8080/";
    backednUrl = "http://localhost:8080/daskal/";
    wbBackendUrl = "http://localhost:8080/wb/"
    */
    chatCallbacks=[];
    registerForOnChat(c){
        this.chatCallbacks.push(c);
    }
    onChat(m){
        for (let c of this.chatCallbacks)
            c.onChat(m);
    }
    groupId = null;
    userHash="";
    teacher=false;
    setHash(userHash){
        this.userHash = userHash;
    }
    ws: any;
    connect(){
        this.ws.connect();
    }
    onClose(cb){
        //this.ws.onclose = cb;
        this.ws.onClose(cb);
    }
    onOpen(cb){
        //this.ws.onopen = cb;
        this.ws.onOpen(cb);
    }
    onMessage(cb){
        //this.ws.onmessage=cb;
        this.ws.onMessage(cb);
    }
    send(cmd, data={}) {
        data['cmd']=cmd;
        data['from']=this.userHash;
        if (cmd!='hb')
        console.log("Will send ", JSON.stringify(data))
        this.ws.send(data).subscribe(observer => {
       //     console.log("message sent", JSON.stringify(data));
        });
    }
    close(){
        if (this.ws){
            try{
                this.ws.close();
            }catch(err){
                console.error(err);
            }
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/utils/network/ws.service.ts